// Generate a random session ID
const generateSessionId = () => {
  return 'session_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
};

// Get the current session ID or create a new one
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('sessionId');
  
  // Also try localStorage as a fallback for better persistence
  if (!sessionId) {
    sessionId = localStorage.getItem('sessionId');
  }
  
  if (!sessionId) {
    sessionId = generateSessionId();
    // Store in both sessionStorage and localStorage for better persistence
    sessionStorage.setItem('sessionId', sessionId);
    localStorage.setItem('sessionId', sessionId);
  } else {
    // If we got it from localStorage, also store it in sessionStorage
    if (!sessionStorage.getItem('sessionId')) {
      sessionStorage.setItem('sessionId', sessionId);
    }
  }
  
  return sessionId;
};

// Clear session ID (useful for logout or errors)
const clearSessionId = () => {
  sessionStorage.removeItem('sessionId');
  localStorage.removeItem('sessionId');
};

export const session = {
  getSessionId,
  clearSessionId
}; 